// extracted by mini-css-extract-plugin
export default {"updateIllustration":"I4BCxdVsoGMnQmmusYfY","placeHolderShimmer":"_LuBYLmCfTGkhIDKQ_ZU"};